import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { SOLUTIONS, SITE } from "@/config/site";

export default function ReferralDisclosure() {
  return (
    <>
      <Seo
        title="Referral Disclosure"
        description="DJC Global may receive compensation from certain referrals. See how our referral relationships work and which providers participate."
        path="/referral-disclosure"
      />
      <PageHero
        eyebrow="Referral Disclosure"
        title="Straight about how this works."
        sub="DJC Global connects businesses with independent solution providers. For some of those connections, DJC Global may receive compensation."
      />
      <section className="bg-platinum pb-20 pt-4" data-testid="disclosure-body">
        <div className="mx-auto max-w-3xl space-y-10 px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="space-y-4 leading-relaxed text-ink/75" data-testid="disclosure-summary">
              <p>
                <strong className="font-semibold text-ink">Compensation.</strong> When you follow a
                referral link on this site, or accept an introduction we make, DJC Global may
                receive compensation from the provider — such as a referral fee or commission. This
                compensation never changes what a provider charges you, and it never changes what we
                tell you about fit.
              </p>
              <p>
                <strong className="font-semibold text-ink">Independent providers.</strong> Each
                provider is an independent company. They deliver their own services, set their own
                prices and terms, determine eligibility, and are solely responsible for outcomes.
                DJC Global does not deliver, warrant, or guarantee any provider's services, savings,
                refunds, or results.
              </p>
              <p>
                <strong className="font-semibold text-ink">Your choice.</strong> You are never
                required to submit a form or speak with DJC Global before visiting a provider —
                every partner link on this site is direct.
              </p>
              <p>
                <strong className="font-semibold text-ink">Verify before you decide.</strong> Program
                terms, eligibility, and pricing change. Confirm current details with the provider
                directly, and consult your own tax, legal, and financial advisors before acting.
              </p>
              <p>
                <strong className="font-semibold text-ink">Effective date:</strong> [Owner to confirm]
                &nbsp;·&nbsp;
                <strong className="font-semibold text-ink">Jurisdiction:</strong> [Owner to confirm]
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.06}>
            <div data-testid="disclosure-partners">
              <h2 className="border-b border-silver/60 pb-4 font-display text-xl font-bold text-ink">
                Current referral destinations
              </h2>
              <ul className="mt-4 divide-y divide-silver/50">
                {SOLUTIONS.map((s) => (
                  <li key={s.id} className="flex flex-col gap-1 py-4 sm:flex-row sm:items-baseline sm:justify-between">
                    <div>
                      <p className="font-display text-sm font-semibold text-ink">{s.name}</p>
                      <p className="text-xs text-ink/55">Provider: {s.provider}</p>
                    </div>
                    <a
                      href={s.cta.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`disclosure-link-${s.slug}`}
                      className="break-all text-xs text-cobalt underline decoration-silver/60 underline-offset-2 hover:decoration-cobalt"
                    >
                      {s.cta.url}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="text-sm leading-relaxed text-ink/60">
              Questions about this disclosure? Email{" "}
              <a href={`mailto:${SITE.email}`} className="font-semibold text-cobalt hover:text-midnight">
                {SITE.email}
              </a>{" "}
              or call{" "}
              <a href={SITE.phoneHref} className="font-semibold text-cobalt hover:text-midnight">
                {SITE.phone}
              </a>
              .
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
